import React, {useEffect , useState} from 'react';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

export const DeviceRepairSelectIssue=(props)=>{
    const [subCauseError, setSubCauseError] = useState('');
    const selectedData =  props.selectedSubscriber.causeList[props.index] ?? {selectedCauseType: '', selectedCauseSubType: '',error: ''};
    var subTypeError = props.isSubmit &&  isNullOrEmpty(selectedData.selectedCauseSubType)  ? 'הנך מתבקש לבחור נושא תקלה' : selectedData.error;
    const subOptions = props.causeOptions.find((opt) => {
      return opt.value == selectedData?.selectedCauseType;
    });
   

    const validateSubCauseType = (value) => {
    var subCauseExist =props.selectedSubscriber.causeList.some((cause, i) => i !== props.index
     && cause.selectedCauseSubType == value 
     && cause.selectedCauseType == selectedData.selectedCauseType
     );
     var error = subCauseExist ? 'נושא תקלה כבר קיים' : '';
      props.saveSelectedCauseType( {selectedCauseSubType : value , error: error}, props.index)
     }


    

    return (
      <div className='cause-item-container'>
         <span className='m-title'> 
           { props.index+1 == props.selectedSubscriber.causeList.length ? 
               'מה סוג התקלה?' :
               `תקלה ${props.index + 1}`
           } 
           </span> 

        <div className='cause-item-type'>
          <span>סוג תקלה<span className="cellcom-color">*</span></span>
          <ReactSelect
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.value}
            placeholder=''
            value={props.causeOptions.find((opt) => {
              return opt.value == selectedData?.selectedCauseType;
            })??''}
            options={props.causeOptions}
            onChange={(e) => props.saveSelectedCauseType( { selectedCauseType: e.value}, props.index)}
            error={props.isSubmit &&  isNullOrEmpty(selectedData.selectedCauseType)   ? 'הנך מתבקש לבחור סוג תקלה' : ''}
          />
        </div>
        <div className='cause-item-subtype'>
          <span>נושא<span className="cellcom-color">*</span></span>
          <ReactSelect
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.value}
            placeholder=''
            value={subOptions?.subOptions.find((opt) => {
              return opt.value == selectedData?.selectedCauseSubType;
            }) ?? ''}
            options={ subOptions?.subOptions }
            onChange={(e) => validateSubCauseType(e.value)}
            error={subTypeError}
          />
        </div>
      </div>
    );
  };
  